import { StockFundamentals, StockFundamentalsHeaders } from "@/models/stock-fundamentals";
import { List } from "@/models/table";
import axios from "axios";

export const getStockFundamentalsInfo = async (stockId: number, range: string, params: {}) => {
    const res = await axios.get<List<StockFundamentals, StockFundamentalsHeaders>>(`/API/v2/id/${stockId}/fundamentals/list/${range}/info`, { params });

    return res.data;
};
